import { DisplayPosition } from '@/common/manager/position/display-position';
import { CnInput, componentMap as formComponentMap } from '@cainiaofe/cn-ui';
import { handleBizExtendComponentProps } from '@/common/manager/plugin';
import { setAdvancedConfigToProps } from '@/common/util/util';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'Input',
    component: CnInput,
    formComponent: formComponentMap.CnInput,
    formItemBeforeHandler: (formItem) => {
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            if (componentProps) {
                componentProps.showLimitHint = true;
            }
            handleBizExtendComponentProps(componentProps, 'CnInput');
            setAdvancedConfigToProps(componentProps);
        }
    },
    filterItemBeforeHandler: (filterItemProps, config) => {
        const { componentProps } = config || {};
        if (componentProps) {
            componentProps.showLimitHint = true;
        }
    },
};
